import { useState, useEffect, MutableRefObject } from 'react';

type MousePosition = {
  x: number | null;
  y: number | null;
};

const useMousePosition = (ref: MutableRefObject<HTMLDivElement | null>): MousePosition => {
  const [mousePosition, setMousePosition] = useState<MousePosition>({ x: null, y: null });

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (ref.current && ref.current.contains(event.target as Node)) {
        setMousePosition({
          x: event.clientX,
          y: event.clientY,
        });
      }
    };

    const handleTouchMove = (event: TouchEvent) => {
      if (ref.current && ref.current.contains(event.target as Node)) {
        setMousePosition({
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
        });
      }
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [ref]);

  return mousePosition;
};

export default useMousePosition;
